<template>
  <div class="bid-left-top">
    <div class="bid-title">Countdown to Next Round : <span class="bid-blocknum">{{ blocknum }}</span> Blocks
      <!--       <el-statistic ref="statistic" :value="blocknum" time-indices>
              <template slot="formatter">
                {{ blocknum }}
              </template>
               blocks
            </el-statistic>-->
    </div>

    <!--    <div class="spaceCenter">
          <div class="bid-time-min spaceCenter">
            <div class="bid-time-text">
              <div class="bid-time-text-big">{{ mm }}</div>
              <div class="bid-time-text-sm">MIN</div>
            </div>
          </div>
          <span class="bid-time-spot">:</span>
          <div class="bid-time-sec spaceCenter">
            <div class="bid-time-text">
              <div class="bid-time-text-big">{{ ss }}</div>
              <div class="bid-time-text-sm">SEC</div>
            </div>
          </div>
        </div>-->
    <!-- <el-progress
      class="bid-progress common-progress"
      :percentage="sliderVal"
      :show-text="false"
    ></el-progress> -->
  </div>
</template>

<script>
import {getNowTime} from "@/api/contract.js";

export default {
  components: {},
  data() {
    return {
      /*mm: "0",
      ss: "0",
      timeTotal: 0,
      now: null,
      timer: null*/
      blocknum: '--'
    };
  },
  methods: {
    /*setTime() {
      if (this.timeTotal <= 0) return false
      this.timer = setInterval(() => {
        if (this.timeTotal <= 0) {
          clearInterval(this.timer)
          this.timer = null
          // this.$emit('finish')
          // this.init(true)
          this.mm = '0'
          this.ss = '0'
          return false;
        }
        this.mm = this.moment(this.timeTotal).minute()
        this.ss = this.moment(this.timeTotal).second()
        this.timeTotal = this.timeTotal - 1000
      }, 1000)
    },
    async getBidTime() {
      if (this.getToken()) {
        this.contractBid = this.$store.getters.contractMap['contractBid'].contract
        this.contractBidAddress = this.$store.getters.contractMap['contractBid'].address
        let res = await this.contractBid.methods["roundStartBlock"]().call({
          from: this.$store.getters.metaMaskObj.account,
        });
        console.dir(res);
        this.startBlock = res;
        this.curBlock = await web3.eth.getBlockNumber();
        this.timeTotal = res * 1000 + (1000 * 60 * 5) - Date.now()
      }
    },
    init(f) {
      // if (f) {
      //   this.timeTotal = Date.now() + (1000 * 60 * 5)
      //   console.log(this.timeTotal)
      //   this.setTime();
      // } else {
      //   this.getBidTime().then(() => {
      //     this.setTime();
      //   })
      // }
      this.getBidTime().then(() => {
        this.setTime();
      })*/

    init(f) {
      this.setBlock();
    },

    async setBlock() {

      /*this.timer = setInterval(async () => {
        let curBlock = await web3.eth.getBlockNumber();
        if (!this.startBlock || +this.startBlock + 60 - curBlock < 0) {
          this.startBlock = await this.getStartBlock();
        }
        this.ss = +this.startBlock + 60 - curBlock;
      }, 5000)*/

      web3.eth.subscribe('newBlockHeaders', async (err, res) => {
        if (!err) {
          let curBlock = res.number;
          if (!this.startBlock || +this.startBlock + 60 - curBlock < 0) {
            this.startBlock = await this.getStartBlock();
          }
          if(this.blocknum < +this.startBlock + 60 - curBlock){
            this.$emit('finish');
          }
          this.blocknum = +this.startBlock + 60 - curBlock;
        }
      });

    },

    async getStartBlock() {
      this.contractBid = this.$store.getters.contractMap['contractBid'].contract
      this.contractBidAddress = this.$store.getters.contractMap['contractBid'].address
      let res = await this.contractBid.methods["roundStartBlock"]().call({
        from: this.$store.getters.metaMaskObj.account,
      });
      console.dir(res);
      return res;
    }
  },
  created() {

    this.init()
  },
  beforeDestroy() {
    window.clearInterval(this.timmer);
  }
};
</script>
<style scoped lang="scss">
.bid-left-top {
  height: 0.84rem;
  text-align: center;
}

.bid-progress {
  margin: 0.35rem 0 0 0;
}

.bid-time-min,
.bid-time-sec {
  width: 0.84rem;
  height: 0.84rem;
  background: rgba(255, 255, 255, .1);
  box-shadow: 0 0.02rem 0.4rem 0 rgba(0, 0, 0, 0.05);
  border-radius: 0.04rem;
}

.bid-time-text-big {
  font-size: 0.28rem;
  font-weight: bold;
  color: #3172FD;
  line-height: 0.36rem;
  letter-spacing: 0.01rem;
}

.bid-blocknum {
  font-size: 0.28rem;
  font-weight: bold;
  color: #38F4BA;
  line-height: 0.36rem;
  letter-spacing: 0.01rem;
}

.bid-time-text-sm {
  font-size: 0.16rem;
  font-weight: 400;
  color: #ADADAD;
  line-height: 0.19rem;
  font-family: DMSans-Regular;
}

.bid-time-spot {
  font-size: 0.32rem;
  font-weight: bold;
  color: #ADADAD;
  margin: 0 0.16rem;
}

.bid-title {
  font-size: 0.2rem;
  font-weight: 500;
  color: #6B6B6B;
  line-height: 0.84rem;
  float: left;
  font-family: DMSans-Regular;
  margin-right: 0.2rem;
}
</style>
